export default __webpack_public_path__ + "static/linkBg2_shadow-b1ce97174ab88037bd75c122afacd3db.png";